import { classNames, ResponsiveStringValue, setCssVar } from "@punks/ui-core"


export const responsiveCssVariables = (name: string, value?: ResponsiveStringValue) => {
    return {
        ...(!!value?.xs && setCssVar(`--${name}`, value?.xs)),
        ...(!!value?.sm && setCssVar(`--${name}-sm`, value?.sm)),
        ...(!!value?.md && setCssVar(`--${name}-md`, value?.md)),
        ...(!!value?.lg && setCssVar(`--${name}-lg`, value?.lg)),
        ...(!!value?.xl && setCssVar(`--${name}-xl`, value?.xl)),
    }
}

export const responsiveClasses = (classes: ResponsiveStringValue, value?: ResponsiveStringValue) => {
    return classNames({
        ...!!classes?.xs ? {
            [classes.xs]: !!value?.xs,
        } : {},
        ...!!classes?.sm ? {
            [classes.sm]: !!value?.sm,
        } : {},
        ...!!classes?.md ? {
            [classes.md]: !!value?.md,
        } : {},
        ...!!classes?.lg ? {
            [classes.lg]: !!value?.lg,
        } : {},
        ...!!classes?.xl ? {
            [classes.xl]: !!value?.xl,
        } : {},
    })
}